/**
 * Enum listant les types d'éléments affichés dans le designer de workflow.
 */
export enum WorkflowElementType {
    /**
     * Elément de type trigger.
     */
    Trigger,
    /**
     * Elément de type action.
     */
    Action,
    /**
     * Elément de type évènement.
     */
    Event,
    /**
     * Elément de type étape.
     */
    Step,
}
